<template>

    <div id="steps-view">
        <div class="divide-y divide-grey-separator">
            <div class="flex pb-5 pt-8" v-if="daterequired">
                <ria-datepicker :dataCalendar='product' @selectedDate="selectedDateSearch($event)"></ria-datepicker>
            </div>

            <div v-for="(participant) in participants" :key="participant.id">
                <div class="flex justify-between pt-4 pb-4">
                    <div class="text-left" v-bind:class="active ? 'opacity-100' : 'opacity-25'">
                        <span class="text-base block">{{ translate(participant, 'name') }} {{ translate(participant, 'description') ? `(${translate(participant, 'description')})` : '' }}</span>
                        <div class="text-grey-text font-light inline-block pr-2" v-bind:class="getoriginalPrice(participant.id) !== getPrice(participant.id) ? 'line-through' : ''">{{getoriginalPrice(participant.id) | money }}</div>
                        <span v-if="getoriginalPrice(participant.id) !== getPrice(participant.id)" class="inline-block text-info">{{ getPrice(participant.id) | money }}</span>
                    </div>
                    <div class="buttons-select flex items-center">
                        <inline-svg
                          class="remove-participant-button"
                          @click="removeParticipant(participant.id)"
                          :src="getParticipantCount(participant.id) === 0 ? '/img/icons/icon-restar-disabled.svg' : '/img/icons/icon-restar.svg'"
                        />
                        <span class="pl-6 pr-6 text-lg" v-bind:class="active ? 'opacity-100' : 'opacity-25'">{{ getParticipantCount(participant.id) }}</span>
                        <inline-svg
                          class="add-participant-button"
                          @click="addParticipant(participant)"
                          :src="activeAdd ? '/img/icons/icon-sumar.svg' : '/img/icons/icon-sumar-disabled.svg'"
                        />
                    </div>
                </div>
            </div>

            <div class="py-4">
                <div class="w-full flex justify-end items-end" v-bind:class="details.length > 0 ? 'opacity-100' : 'opacity-25'">
                    <span class="pb-1 pr-3">Total</span>
                    <b class="text-2xl">{{ totalPrice | money }}</b>
                </div>
                <ria-button v-bind:class="details.length > 0 ? '' : 'bg-grey-bg'" class="button-continue block mx-0 my-5 uppercase lg:float-right" :text="i18n.t('when.continue')" :action="nextStep" :fullwidth="size === 'sm'"/>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import RiaButton from "../components/common/ria-button";
import RiaDatepicker from "../components/form/elements/ria-datepicker";
import {translate}  from '@/helpers/translationsHelpers.js';
import i18n from '../i18n'
import {keepScroll} from "../mixins";

export default {
    metaInfo() {
        return { 
            title: `${this.$t('steps.meta.title')} - ${this.resort.name}`,
            meta: [
                { name: 'description', content:  this.$t('steps.meta.description')}, 
            ]
        }
    },
    mixins: [keepScroll],
    data(){
        return{
            i18n: i18n,
            prices: [],
            participants: [],
            changedDate: false,
            date: null,
            capacity: undefined
        }
    },
    components: {
        RiaButton,
        RiaDatepicker
    },
    computed: {
        ...mapGetters("device", ["size"]),
        ...mapGetters("prices", ["product"]),
        ...mapGetters("resort", ["resort", "selectedProduct", "selectedCatalog"]),
        ...mapGetters("order", ["order", "totalPrice", "details"]),
        daterequired: function() {
            return this.selectedProduct.requirements.date
        },
        active: function() {
          return !this.daterequired 
          || (this.daterequired && this.changedDate)
        },
        activeAdd: function() {
          if(this.capacity != undefined){
            return this.capacity[1].capacity > this.details.length
            && (!this.daterequired || (this.daterequired && this.changedDate))
          }
          else {
            return !this.daterequired 
            || (this.daterequired && this.changedDate)
          }
        }
    },
    methods: {
        ...mapActions("order", ["addDetail", "removeDetail", "changeDetailsField", "sortDetails"]),

        nextStep() {
            if (this.details.length > 0){
                this.$router.push({ name: 'Participants'})
            }
        },

        getoriginalPrice(participantId){
          return this.prices.find(price => price.participant_id == participantId).originalPrice
        },

        getPrice(participantId) {
          return this.prices.find(price => price.participant_id == participantId).price
        },

        getParticipantCount(participantId) {
          return this.details.filter(detail => detail.participant_id == participantId).length
        },

        addParticipant(participant) {
          if (this.activeAdd) {
            this.addDetail({ date: this.date, participant })
            this.sortDetails()
          }
        },

        removeParticipant(participantId) {
          if (this.active) {
            this.removeDetail({ participantId })
          }
        },

        selectedDateSearch(date) {
            this.prices = Object.entries(this.product[date]).map((participantPrice) => ({ participant_id: participantPrice[0], price: participantPrice[1].best_amount, originalPrice: participantPrice[1].original_amount}))
            this.date = date;
            this.changedDate = true;
            this.capacity = Object.entries(this.product[this.date]).find(date => date[1].capacity)

            if (this.details.length > 0) {
                this.changeDetailsField({ field: 'date', value: date });
            }
        },

        setup() {
            const participantsIds = Object.entries(this.product.best_prices)
              .filter((participantType) => participantType[1].best_amount !== null)
              .map((participantType) => participantType[0])

            this.participants = this.selectedCatalog.participants
              .filter(participant => participantsIds.includes((participant.id).toString()));

            this.prices = this.daterequired
              ? participantsIds.map(participantId => ({ participant_id:  participantId, price: 0, originalPrice: 0}))
              : this.participants.map(participant => ({ participant_id: participant.id, price: this.product['best_prices'][participant.id].best_amount , originalPrice: this.product['best_prices'][participant.id].original_amount}))
        },

        translate(object, field) {
            return translate(object, field)
        },
    },

    created() {
      this.setup()
      if(this.details.length > 0){
        this.selectedDateSearch(this.details[0].date)
      }
    },

};
</script>

<style scoped>
  #steps-view {
    @apply bg-white px-6
  }

  .buttons-select{
      right: 25px;
  }

  .add-participant-button, .remove-participant-button {
    @apply cursor-pointer;
  }
</style>
